export const deskPersonalTrainingData = [
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textAwm.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/weight-nutrition-adults",
    firstName:"Nutrition And Weight",
    secondName:"Management For Adults"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textKwm.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/weight-nutrition-kids",
    firstName:"Nutrition And Weight",
    secondName:"Management For Kids"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textMed.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/meditation-mindfulness",
    firstName:"Meditation and",
    secondName:"Mindfullness"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textPt.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/physical-training",
    firstName:"Physical",
    secondName:"Training"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textPilates.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/pilates",
    firstName:"Pilates",
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textYoga.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/yoga-flexibility",
    firstName:"Yoga & Flexibility",
  },
];

export const mobPersonalTrainingData = [
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textAwm.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/weight-nutrition-adults",
    firstName:"Nutrition And Weight",
    secondName:"Management For Adults"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textKwm.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/weight-nutrition-kids",
    firstName:"Nutrition And Weight",
    secondName:"Management For Kids"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textMed.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/meditation-mindfulness",
    firstName:"Meditation and",
    secondName:"Mindfullness"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textPt.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/physical-training",
    firstName:"Physical",
    secondName:"Training"
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textPilates.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/pilates",
    firstName:"Pilates",
  },
  {
    imageURL: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/non-textYoga.png",
    redirectionURL: "https://www.khelomore.com/sports-coaching/get-a-coach/yoga-flexibility",
    firstName:"Yoga & Flexibility",
  },
];